<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardHeader>
          <CCol>
            <strong>Institute Chain Details</strong>
          </CCol>
        </CCardHeader>
        <CCardBody>
          <CTabs add-tab-classes="mt-1">
            <span @click="selected = 'InstituteChainEdit'">
              <CTab>
                <template slot="title">
                  Basic Details
                </template>
              </CTab>
            </span>
            <span @click="selected = 'InstituteChainInstitutes'">
              <CTab>
                <template slot="title">
                  Assign Institutes
                </template>
              </CTab>
            </span>
            <span @click="selected = 'InstituteChainMember'">
              <CTab>
                <template slot="title">
                  Members
                </template>
              </CTab>
            </span>
          </CTabs>
          <component :is="selected" @changeSelected="getTab($event)" style="margin-top: 20px"></component>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import { Mixin } from "/src/mixins/index.js";
import InstituteChainEdit from "./tab/InstituteChainEdit";
import InstituteChainInstitutes from "./tab/InstituteChainInstitutes";
import InstituteChainMember from "./tab/InstituteChainMember";
export default {
  name: "instituteChainEdit",
  mixins: [Mixin],
  components: {
    InstituteChainEdit,
    InstituteChainInstitutes,
    InstituteChainMember
  },
  data() {
    return {
      selected: "InstituteChainEdit"
    };
  }
};
</script>